import './MainLayout.scss';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';

import TopBar from './TopBar';
import { useAuth } from '../session/InternalAuthProvider';
import MainSidebar, { mainSidebarWidth } from './sideBar/MainSidebar';

const MainLayout = () => {
  const location = useLocation();
  const isCalendarRoute = location.pathname.includes('/dashboard/calendar');

  const { authState } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const contextValue = {
    isSidebarOpen,
    setIsSidebarOpen,
  };
  const { i18n } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  useEffect(() => {
    const defaultLang = authState.account.default_system_language || 'he';
    const localStorageLanguage = localStorage.getItem('calendar_language');
    if (localStorageLanguage && localStorageLanguage !== 'undefined') {
      return;
    }
    void i18n.changeLanguage(defaultLang);
    document.body.dir = i18n.dir();
    theme.direction = i18n.dir();
    moment.locale(defaultLang);
    localStorage.setItem('calendar_language', defaultLang);
  }, [authState.account]);
  return (
    <Grid
      container
      sx={{
        minHeight: '100vh',
        maxHeight: '100vh',
        overflow: 'hidden',
      }}>
      <Grid
        item
        sx={{
          width: { xs: 0, md: mainSidebarWidth },
          display: { xs: 'none', md: 'block' },
          backgroundImage: 'linear-gradient(rgba(34, 42, 69, 0.96), rgba(34, 42, 69, 0.96))',
        }}>
        <MainSidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      </Grid>

      <Grid
        item
        xs
        container
        flexDirection="column"
        sx={{
          height: '100vh',
          overflow: 'hidden',
          background: '#f8f8f8',
        }}>
        {!isCalendarRoute && isSmallScreen && (
          <Grid item>
            <TopBar fixed isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} className="elevation-z8" />
          </Grid>
        )}
        <Grid
          item
          xs
          sx={{
            overflowY: 'auto',
            height: '100%',
          }}>
          <Outlet context={contextValue} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MainLayout;
